import {getLocalizationBasedOnLang} from '../User/UserInfo';

/*
 * What authors read when a Studio request fails for a reason the server does not explain to
 * them, or names with a code (it words those in English). The Studio's own text (studioText)
 * includes these lines.
 */

export const studioErrorEnglish = {
  genericError: 'Something went wrong. Please try again.',
  // AI actions wait for a stopped generation's AI credits to settle; the server did not say why.
  creditCheckPending:
    "The AI credits from your last generation haven't been settled yet. If your workspace has run out of AI credits, add more, then check again.",
  studioUnavailable:
    'Microreel Studio is not available in this environment yet. Ask your administrator to enable Studio here, or open an environment where Studio is available.',
  storyboardConflict:
    'This storyboard changed in another session. Reload it before trying again.',
  // Studio's rate limit refuses with a bare 429.
  tooManyRequests: 'Too many requests. Wait a moment, then try again.',
  // A request refused with insufficient_credits.
  insufficientCredits:
    'The workspace does not have enough AI credits for this job.',
  // A delete refused with credit_check_pending. The library has no credit check, so it sends
  // the author to the microreel's page, which says what the credits wait for.
  deleteCreditCheckPending:
    "This microreel's AI credits haven't been settled yet, so it can't be deleted. Open it to see what they're waiting for.",
};

export const studioErrorWelsh: typeof studioErrorEnglish = {
  genericError: 'Aeth rhywbeth o’i le. Rhowch gynnig arall arni.',
  creditCheckPending:
    'Nid yw credydau AI eich cynhyrchiad diwethaf wedi’u setlo eto. Os yw eich gweithle wedi rhedeg allan o gredydau AI, ychwanegwch ragor, yna gwiriwch eto.',
  studioUnavailable:
    'Nid yw Microreel Studio ar gael yn yr amgylchedd hwn eto. Gofynnwch i’ch gweinyddwr alluogi Studio yma, neu agorwch amgylchedd lle mae Studio ar gael.',
  storyboardConflict:
    'Newidiodd y bwrdd stori hwn mewn sesiwn arall. Ail-lwythwch ef cyn rhoi cynnig arall arni.',
  tooManyRequests:
    'Gormod o geisiadau. Arhoswch eiliad, yna rhowch gynnig arall arni.',
  insufficientCredits:
    'Nid oes gan y gweithle ddigon o gredydau AI ar gyfer y gwaith hwn.',
  deleteCreditCheckPending:
    'Nid yw credydau AI y microreel hwn wedi’u setlo eto, felly nid oes modd ei ddileu. Agorwch ef i weld am beth maen nhw’n aros.',
};

export const studioErrorText: typeof studioErrorEnglish =
  getLocalizationBasedOnLang(studioErrorEnglish, studioErrorWelsh);
